export enum ProdutoLocalEstoqueStatus {
    Ativado = 1,
    Desativado = 2,
}
